import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import Reveal from "@/components/motion/Reveal";

export default function Testimonials() {
  return (
    <section className="relative bg-[#050505] py-24 sm:py-32" data-testid="testimonials">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal className="mb-14">
          <p className="mb-4 flex items-center gap-3 font-body text-[11px] font-bold uppercase tracking-[0.3em] text-volt">
            <span className="h-px w-10 bg-volt" /> Kundenstimmen
          </p>
          <h2 className="font-heading text-4xl font-black uppercase leading-[0.9] tracking-tight text-white sm:text-6xl">
            Vertrauen aus<br /><span className="text-volt">der Region</span>
          </h2>
        </Reveal>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="flex flex-col border border-white/10 bg-[#0d0d0d] p-7 transition-colors hover:border-volt/40"
            >
              <Quote className="h-8 w-8 text-volt/40" />
              <div className="mt-4 flex gap-0.5">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="h-4 w-4 fill-volt text-volt" />
                ))}
              </div>
              <p className="mt-4 flex-1 font-body text-sm leading-relaxed text-neutral-300">"{t.text}"</p>
              <div className="mt-6 border-t border-white/10 pt-4">
                <p className="font-heading text-lg font-bold uppercase text-white">{t.name}</p>
                <p className="font-body text-xs text-neutral-500">{t.place} · {t.service}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
